import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import {
  CPRS_MAIN_CONTENT,
  OUR_INTRODUTION,
} from "@/graphql/main-content-and-introduction-query";
import {
  IntroductionData,
  MainContentData,
} from "@/models/main-content-and-introduction/main-content-and-introduction.interface";
import { utils } from "@/utils/utils";
import { docLibraryData } from "@/models/common-interface/common.interface";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";

@Component({
  components: {
    PreviewPopupComponent,
  },
})
export default class MainContentAndIntroductionComponent extends Vue {
  public mainContent: MainContentData[] = [];
  public ourIntroductionData: IntroductionData[] = [];
  public ourIntroductionImage = {
    name: "",
    url: "",
  };
  public ourIntroductionSubImage = {
    name: "",
    url: "",
  };
  public getAllDoc: docLibraryData[] = [];
  public showPreviewPopup = false;
  public previewFile: any[] = [];

  // Type-based (order-independent): the intro is the entry without an
  // endorsement tag; endorsements are the entries that have a tag.
  public get introEntry(): IntroductionData | undefined {
    return this.ourIntroductionData.find((entry) => !entry.attributes?.tag);
  }

  public get endorsementEntries(): IntroductionData[] {
    return this.ourIntroductionData.filter((entry) => !!entry.attributes?.tag);
  }

  public get endorsementSectionTitle(): string {
    return (
      this.endorsementEntries[0]?.attributes?.endorsement_section_title || ""
    );
  }

  public get endorsementSectionDescription(): string {
    return (
      this.endorsementEntries[0]?.attributes?.endorsement_section_description ||
      ""
    );
  }

  public cardImageUrl(entry: IntroductionData): string {
    const image = entry?.attributes?.image;
    if (!image || !image.data) {
      return "";
    }
    return image.data.attributes.url;
  }

  public cardImageName(entry: IntroductionData): string {
    const image = entry?.attributes?.image;
    return image && image.data ? image.data.attributes.name : "";
  }

  // Apply Here: route by role. Reviewers go to the endorsement review list;
  // applicants (and not-logged-in users) go to the application form, which
  // redirects to login itself when there is no session.
  public onApplyEndorsement(): void {
    const userDetails = utils.getUserDetails();
    if (
      userDetails &&
      userDetails.roles &&
      userDetails.roles.includes("REVIEWER")
    ) {
      this.$router.push("/reviewer-dashboard/cprs-j");
    } else {
      this.$router.push("/form/endorsements");
    }
  }

  public async created() {
    await utils.getAllDoc().then((data) => {
      this.getAllDoc = data;
    });
    await this.$apollo
      .query({
        query: gql`query ${CPRS_MAIN_CONTENT}`,
      })
      .then((result) => {
        this.mainContent = result.data.cprsMainContents.data;
      });
    await this.$apollo
      .query({
        query: gql`query ${OUR_INTRODUTION}`,
      })
      .then((result) => {
        this.ourIntroductionData = result.data.ourIntroductions.data;
        const intro = this.introEntry;
        if (intro?.attributes?.image?.data) {
          this.ourIntroductionImage = {
            name: intro.attributes.image.data.attributes.name,
            url: intro.attributes.image.data.attributes.url,
          };
        }
        if (intro?.attributes?.sub_image?.data) {
          this.ourIntroductionSubImage = {
            name: intro.attributes.sub_image.data.attributes.name,
            url: intro.attributes.sub_image.data.attributes.url,
          };
        }
      });
  }

  public updated() {
    window.document.onclick = (e) => {
      if (e.target !== null) {
        const getElement: HTMLElement = e.target as HTMLElement;
        const tagId = getElement.id;
        const getDocElement: HTMLAnchorElement = document.getElementById(
          tagId
        ) as HTMLAnchorElement;
        if (getDocElement) {
          const docDetials = utils.filterDoc(this.getAllDoc, tagId);
          if (docDetials) {
            this.showPreviewPopup = true;
            this.previewFile = [
              {
                fileName: "",
                width: 0,
                height: 0,
                type: docDetials.mime,
                originalFileName: docDetials.name,
                url: docDetials.url,
              },
            ];
          }
        }
      }
    };
  }

  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewFile = [];
    }
  }
}
